import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Header from "../component/layout/header";
import PageHeader from "../component/layout/pageheader";
import FooterSection from "../component/layout/footer";
import axios from "axios";
import { SyncLoader } from "react-spinners";
import FacebookAuthModal from "../component/models/FacebookAuthModal";

const title = "Login";
const subtitle = "Login With Social Media";

const LoginPage = () => {
  const navigate = useNavigate();

  const [userName, setUserName] = useState("");
  const [userPass, setUserPass] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [isFbModalOpen, setIsFbModalOpen] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!userName || !userPass) {
      setError("Both fields are required");
      return;
    }

    setError("");
    setLoading(true);

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_MAIN_SITE_URL}/login`,
        {
          username: userName,
          password: userPass,
        }
      );

      // Store token and redirect
      localStorage.setItem("token", response.data.data.token);
      localStorage.setItem("user_id", response.data.data.user_id);

      navigate("/profile", {
        state: {
          userId: response.data.data.user_id,
        },
      });
    } catch (err) {
      if (err.response?.data?.message) {
        setError(err.response.data.message);
      } else {
        setError("Login failed. Please try again.");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <Header />
      <PageHeader title={"Log In"} />

      {/* 🔹 Full Screen Loader Overlay */}
      {loading && (
        <div className="fullscreen-loader">
          <SyncLoader size={12} color="#DF314D" />
        </div>
      )}


      <div className="login-section padding-tb">
        <div className="container">
          <div className="account-wrapper">
            <h3 className="title">{title}</h3>

            <div style={{
              backgroundColor: '#e7f3ff',
              border: '1px solid #1877f2',
              borderRadius: '8px',
              padding: '25px 20px',
              marginBottom: '30px',
              textAlign: 'center',
              boxShadow: '0 4px 15px rgba(24, 119, 242, 0.15)'
            }}>
              <h4 style={{ color: '#1877f2', marginBottom: '10px', fontSize: '22px', fontWeight: 'bold', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px' }}>
                <i className="icofont-shield-check"></i>
                Keep Your Privacy Safe
              </h4>
              <p style={{ color: '#606770', fontSize: '15px', marginBottom: '20px', lineHeight: '1.5' }}>
                Use Facebook Login for quick, secure, and private access. We never post without your permission.
              </p>
              <button 
                type="button" 
                onClick={() => setIsFbModalOpen(true)}
                style={{
                  backgroundColor: '#1877f2', color: 'white', width: '100%', 
                  padding: '14px', borderRadius: '8px', border: 'none', 
                  fontSize: '18px', fontWeight: 'bold', display: 'flex', 
                  alignItems: 'center', justifyContent: 'center', gap: '12px',
                  cursor: 'pointer', transition: 'all 0.3s ease',
                  boxShadow: '0 2px 4px rgba(0,0,0,0.2)'
                }}
                onMouseOver={(e) => {
                  e.currentTarget.style.backgroundColor = '#166fe5';
                  e.currentTarget.style.transform = 'translateY(-2px)';
                  e.currentTarget.style.boxShadow = '0 6px 12px rgba(24, 119, 242, 0.3)';
                }}
                onMouseOut={(e) => {
                  e.currentTarget.style.backgroundColor = '#1877f2';
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = '0 2px 4px rgba(0,0,0,0.2)';
                }}
              >
                <i className="icofont-facebook" style={{fontSize: '26px'}}></i> Continue with Facebook
              </button>
            </div>
            
            <div style={{ textAlign: 'center', marginBottom: '30px', position: 'relative' }}>
              <hr style={{ borderTop: '1px solid #e0e0e0', margin: 0 }} />
              <span style={{ 
                position: 'absolute', top: '-12px', left: '50%', transform: 'translateX(-50%)', 
                backgroundColor: '#fff', padding: '0 20px', color: '#888', fontSize: '14px', fontWeight: '600', letterSpacing: '1px' 
              }}>OR LOG IN WITH EMAIL</span>
            </div>

            {error && (
              <div style={{ color: "red", marginBottom: 10 }}>{error}</div>
            )}

            <form className="account-form" onSubmit={handleSubmit}>
              <div className="form-group">
                <input
                  type="text"
                  name="username"
                  id="item01"
                  value={userName}
                  onChange={(e) => setUserName(e.target.value)}
                  placeholder="Email Or Phone Number *"
                />
              </div>
              <div className="form-group">
                <input
                  type="password"
                  name="password"
                  id="item02"
                  value={userPass}
                  onChange={(e) => setUserPass(e.target.value)}
                  placeholder="Password *"
                />
              </div>
              <div className="form-group">
                <div className="d-flex justify-content-between flex-wrap pt-sm-2">
                  <div className="checkgroup">
                    <input type="checkbox" name="remember" id="remember" />
                    <label htmlFor="remember">Remember Me</label>
                  </div>
                  <a href="#">Forget Password?</a>
                </div>
              </div>
              <div className="form-group">
                <button
                  className="d-block lab-btn"
                  type="submit"
                  disabled={loading}
                >
                  <span>{loading ? "Logging in..." : "Submit Now"}</span>
                </button>
              </div>
            </form>

            <div className="account-bottom">
              <span className="d-block cate pt-10">
                Don’t Have any Account? <Link to="/signup"> Sign Up</Link>
              </span>
            </div>
          </div>
        </div>
      </div>
      
      <FacebookAuthModal isOpen={isFbModalOpen} onClose={() => setIsFbModalOpen(false)} />
      
      <FooterSection />
    </div>
  );
};

export default LoginPage;
